import { Button, SheetTitle, cn } from "@nexus/ui";
import { useLayoutEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

interface ClampedTitleProps {
  children: string;
  className?: string;
}

const TITLE_CLAMP_LINES = 3;

export function ClampedTitle({ children, className }: ClampedTitleProps) {
  const { t } = useTranslation();
  const ref = useRef<HTMLHeadingElement>(null);
  const [expanded, setExpanded] = useState(false);
  const [overflows, setOverflows] = useState(false);

  useLayoutEffect(() => {
    if (expanded) return;
    const node = ref.current;
    if (!node) return;
    setOverflows(node.scrollHeight > node.clientHeight + 1);
  }, [children, expanded]);

  return (
    <div className="min-w-0">
      <SheetTitle
        ref={ref}
        className={cn(
          "text-[15px] font-medium leading-snug tracking-tight text-foreground [overflow-wrap:anywhere]",
          !expanded && "line-clamp-3",
          className,
        )}
      >
        {children}
      </SheetTitle>
      {overflows || expanded ? (
        <Button
          type="button"
          variant="ghost"
          size="sm"
          className="mt-1 h-7 px-0 text-xs text-muted-foreground hover:text-foreground"
          aria-expanded={expanded}
          onClick={() => setExpanded((current) => !current)}
        >
          {expanded
            ? t("marketplace.orders.list.panel.showLess")
            : t("marketplace.orders.list.panel.showMore")}
        </Button>
      ) : null}
    </div>
  );
}

export { TITLE_CLAMP_LINES };
